import { useMemo } from 'react';

import { AdminViewsFund } from '@/api/admin/types';
import { AllFund } from '@/api/fund/queries';

import { GalleryFundTableItem } from '../gallery-fund-table-item';
import { SkeletonCard } from '../skeleton-card';

const buildDisplayItems = (raw: AdminViewsFund[]): AllFund[] =>
  raw.map((f) => {
    const tvl = typeof f.tvl === 'number' ? f.tvl : null;
    return {
      id: f.id,
      entity: {
        id: f.entityId ?? '',
        name: f.entityName ?? '',
        isEntityApproved: f.isEntityApproved ?? false,
        entityApprovalStatus: f.entityApprovalStatus ?? null,
      },
      name: f.name ?? '',
      displayName: null,
      logoUrl: null,
      coverImageUrl: f.thumbnailUrl ?? null,
      cardImageUrl: f.cardImageUrl ?? null,
      entityLogoUrl: null,
      category: null,
      investmentAvailabilityStatus: f.investmentAvailabilityStatus ?? null,
      draftStatus: null,
      sizeInMillionsUsd: tvl !== null ? tvl / 1_000_000 : null,
      aumInMillionsUsd: null,
      fundApprovalStatus: f.status ?? 'Draft',
      minInvestment: null,
      createdAt: f.createdAt ?? '',
      updatedAt: f.lastUpdated ?? f.createdAt ?? '',
      investors: f.investorsCount ?? 0,
      unitsIssued: f.unitsIssued ?? 0,
      isApproved: false,
      entityName: f.entityName ?? '',
      targetReturnRate: null,
    } as AllFund;
  });

type Props = {
  items: AdminViewsFund[];
  isLoading: boolean;
};

export const FundsGalleryView = ({ items, isLoading }: Props) => {
  const displayItems = useMemo(() => buildDisplayItems(items), [items]);

  if (isLoading) {
    return (
      <>
        {Array.from({ length: 9 }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </>
    );
  }

  return (
    <>
      {displayItems.map((item) => (
        <GalleryFundTableItem key={item.id} item={item} />
      ))}
    </>
  );
};
